<div class="section-container">
  <slot />
</div>

<style>
  .section-container {
    padding: 1rem 1rem;
    border: 1px solid darkgray;
    border-radius: 5px;
  }
</style>
